import { render, staticRenderFns } from "./work-image.vue?vue&type=template&id=10d37ba5&scoped=true"
import script from "./work-image.vue?vue&type=script&lang=js"
export * from "./work-image.vue?vue&type=script&lang=js"
import style0 from "./work-image.vue?vue&type=style&index=0&id=10d37ba5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d37ba5",
  null
  
)

export default component.exports